import i18n from '~/plugins/i18n';
import http from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        ...sort,
        // clearPaymentMethods: !filters.paymentMethodIds.length > 0,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.get('v1/currencies', {
        ...getters.requestData,
        ...data,
      });
      const { items, total } = response.data;
      commit('SET_DATA', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async loadDataLazy({ state, dispatch }, data) {
      if (state.data.length) return;
      await dispatch('loadData', data);
    },

    async edit(__store, { id, ...data }) {
      const response = await http.put(`v1/currencies/${id}`, {
        ...data,
        clearPaymentMethods: !data.paymentMethods.length > 0,
      });

      if (!response?.data?.result?.Success) {
        switch (response?.data?.result?.Error) {
          case 'SameRequisiteExists':
            throw new Error(i18n.t('errors.SameRequisiteExists'));
          case 'RequestNotValid':
            throw new Error(i18n.t('errors.RequestNotValid'));
          case 'SameCurrencyExists':
            throw new Error(i18n.t('errors.SameCurrencyExists'));
          case 'PaymentMethodNotFound':
            throw new Error(i18n.t('errors.PaymentMethodNotFound'));
          default:
            throw new Error(i18n.t('Unexpected error'));
        }
      }
    },

    async create(__store, data) {
      const response = await http.post('v1/currencies', data);

      if (!response?.data?.result?.Success) {
        switch (response?.data?.result?.Error) {
          case 'SameRequisiteExists':
            throw new Error(i18n.t('errors.SameRequisiteExists'));
          case 'RequestNotValid':
            throw new Error(i18n.t('errors.RequestNotValid'));
          case 'SameCurrencyExists':
            throw new Error(i18n.t('errors.SameCurrencyExists'));
          case 'PaymentMethodNotFound':
            throw new Error(i18n.t('errors.PaymentMethodNotFound'));
          default:
            throw new Error(i18n.t('Unexpected error'));
        }
      }
    },
  },

  namespaced: true,
});
